// Main Layout Component

import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useActivityTracker } from '../../hooks/useActivityTracker';
import { useTokenRefresh } from '../../hooks/useTokenRefresh';
import { useSessionTimeout } from '../../hooks/useSessionTimeout';
import { SessionTimeoutWarning } from '../SessionTimeoutWarning';

export function Layout() {
  const activityTracker = useActivityTracker();
  useTokenRefresh(activityTracker);
  const { showWarning, remainingSeconds, stayLoggedIn, dismissWarning } = useSessionTimeout(activityTracker);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
      {showWarning && (
        <SessionTimeoutWarning
          remainingSeconds={remainingSeconds}
          onStayLoggedIn={stayLoggedIn}
          onLogout={dismissWarning}
        />
      )}
    </div>
  );
}
